// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2o4dA","list":"BalanceDue_list__1d94p","listRow":"BalanceDue_listRow__3Dp5O","total":"BalanceDue_total__2A6iO"};